/* The company payload the locked-profile previews render against. */

/* Shaped as the API sends an individual owner: `name` and the record's own
   `ownership_indID` key, NOT the `ownerName`/`ownerId` this fixture used to
   carry — those fields do not exist on the wire. */
const ownership = (ownerName, percentage) => ({
  ownershipID: {
    ownership_indID: {
      ownership_indID: `owner-${percentage}`,
      name: ownerName,
      percentage_of_shares_held: percentage,
      type: "individual",
      is_deleted: 0,
    },
  },
});

const signatory = (designation) => ({
  Authorized_signID: {
    name: "Person Name",
    designation,
    work_email: "email@businessname.com",
    work_mobile: "000 000 0000",
    nationality: "Country Name",
    is_deleted: 0,
  },
});

const personnel = (designation) => ({
  key_personnelID: {
    name: "Person Name",
    designation,
    work_email: "email@businessname.com",
    work_mobile: "000 000 0000",
    is_deleted: 0,
  },
});

export const PREVIEW_COMPANY = {
  registered_company_name: "Business Name",

  /* Registration — the card is suppressed unless one of these is present. */
  registration_body: "Registration Body Name",
  legal_form: "Legal Form",
  license_no: "0000000",
  date_of_issue: "2020-01-01",
  date_of_expiry: "2030-01-01",
  capital: "0,000,000",
  /* Stored as an HTML blob and parsed into coded rows by permittedActivities. */
  activities:
    "<p>0000.00 Activity Name\n0000.00 Activity Name\n0000.00 Activity Name</p>",

  ownershipCompany: [
    ownership("Owner Name", 60),
    ownership("Owner Name", 25),
    ownership("Owner Name", 15),
  ],

  authorizedSignDetails: [signatory("Director"), signatory("Signatory")],

  companyKeyPersonnel: [
    personnel("Director"),
    personnel("Manager"),
    personnel("Finance Lead"),
  ],

  relatedEntity: [
    {
      related_entityID: {
        companyName: "Entity Name",
        companyWIN: "0000000",
        state: "State Name",
        country: "Country Name",
        relation_type: "Subsidiary",
        is_deleted: 0,
      },
    },
  ],

  businessRelation: [
    {
      business_relationID: {
        registered_company_name: "Business Name",
        state: "State Name",
        country: "Country Name",
        relation_type: "Supplier",
        is_deleted: 0,
      },
    },
    {
      business_relationID: {
        registered_company_name: "Business Name",
        state: "State Name",
        country: "Country Name",
        relation_type: "Customer",
        is_deleted: 0,
      },
    },
  ],

  bankDetails: [
    { bankID: { bank_name: "Bank Name", IBAN: "AE00 0000 0000 0000 0000 000", country: "Country Name", is_deleted: 0 } },
  ],

  company_tax: [
    { categoryTitle: "Tax Category", tax_reg_no: "000000000000000", is_deleted: 0 },
  ],

  insuranceDetails: [
    { insuranceID: { insurer: "Insurer Name", type: "Insurance Type", broker: "Broker Name", is_deleted: 0 } },
  ],

  financialDetails: [
    {
      financial_year_end: "31 December",
      last_audited: "2024",
      audit_firm_name: "Audit Firm Name",
      state: "State Name",
      country: "Country Name",
    },
  ],

  /* Documents. The cards are anchors, but they sit inside the blur wrapper,
     which is aria-hidden with pointer-events-none — nothing here is reachable
     or clickable. The extension only drives the file-kind chip. */
  MOA: "memorandum-of-association.pdf",
  VAT_certificate: "vat-certificate.pdf",
  trade_license: "trade-licence.pdf",
};

/* The finance response's own fields, which FinancialsStrip reads directly. */
export const PREVIEW_FINANCE = {
  currency: "UAE dirham",
  units: "Thousands",
  is_currency_verified: false,
};

export default PREVIEW_COMPANY;
